import { motion } from "framer-motion";
import { Car, Sparkles, UserCheck, Leaf } from "lucide-react";

const features = [
  {
    icon: Car,
    title: "Daily Car Wash",
    body: "Doorstep convenience, all 7 days a week",
  },
  {
    icon: Sparkles,
    title: "Premium Quality",
    body: "Showroom shine, no scratches or swirls",
  },
  {
    icon: UserCheck,
    title: "Trained professionals",
    body: "Background verified, Uniformed staff",
  },
  {
    icon: Leaf,
    title: "Eco-Friendly Care",
    body: "Advanced materials, using 90% less water",
  },
];

export default function Solution() {
  return (
    <section
      data-testid="solution-features"
      className="relative py-24 md:py-32 px-6 md:px-12 border-t border-zyp-navy/10 bg-zyp-cream"
    >
      <div className="max-w-7xl mx-auto">
        <div className="flex flex-col md:flex-row md:items-end justify-between gap-8 mb-16">
          <div className="max-w-2xl">
            <div className="text-xs uppercase tracking-[0.22em] text-zyp-navy/60 mb-4">
              Why Zyp
            </div>
            <h2 className="font-heading text-4xl sm:text-5xl font-medium tracking-tight text-zyp-navy">
              Not another car wash. <br />
              A car ownership operating system.
            </h2>
          </div>
          <p className="md:max-w-sm text-zyp-navy/70">
            Built ground-up for the realities of urban Indian apartments. Every
            decision optimised for trust, time and turn-up.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {features.map((f, i) => (
            <motion.div
              key={f.title}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.5, delay: i * 0.08 }}
              data-testid={`solution-feature-${i}`}
              className="rounded-2xl border border-zyp-navy/10 bg-white hover:border-zyp-navy/20 hover:shadow-md transition-all p-8 h-full"
            >
              <div className="h-12 w-12 rounded-xl bg-zyp-highlight/10 border border-zyp-highlight/20 flex items-center justify-center mb-6">
                <f.icon size={22} className="text-zyp-highlight" strokeWidth={1.6} />
              </div>
              <h3 className="font-heading text-xl font-medium tracking-tight text-zyp-navy">
                {f.title}
              </h3>
              <p className="mt-2 text-zyp-navy/70 text-sm leading-relaxed">
                {f.body}
              </p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
